import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

// import Login from '../components/Login'
// import Logout from '../components/Logout'

import Dashboard from '../Screens/DashboardScreen'
import Compile from '../Screens/CompileScreen'
import Diagramm from '../Screens/DiagrammScreen'
import CompileHistory from '../Screens/CompileHistoryScreen'




const routes = [
    { path: '/forecast/view/dashboard', component: Dashboard, name: 'dashboard', },
    { path: '/forecast/view/compile', component: Compile, name: 'compile', },
    { path: '/forecast/view/diagramm', component: Diagramm, name: 'diagramm', },
    { path: '/forecast/view/compileHistory', component: CompileHistory, name: 'compileHistory', },
    { path: '/worklog',name:"worklog",
        beforeEnter() { location.href = 'http://worklog.test/dashboard/works' },
    },
    
]


const router = new VueRouter({
    routes,
    mode: 'history',
})

export default router;